// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__GtB4b","spin":"Spinner_spin__jYDDt","small":"Spinner_small__RZZCT","medium":"Spinner_medium__UHG+l","large":"Spinner_large__or3b+"};